import { render } from "./CommunicationPanel.vue?vue&type=template&id=9c282260&scoped=true"
import script from "./CommunicationPanel.vue?vue&type=script&lang=js"
export * from "./CommunicationPanel.vue?vue&type=script&lang=js"

import "./CommunicationPanel.vue?vue&type=style&index=0&id=9c282260&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c282260"]])

export default __exports__